<div class="flex items-center justify-center h-full w-full">
  <div class="flex flex-col items-center">
    <img src="./assets/img/Nope.png">
    <span class="pt-4">{{'recordNotFound.message' | translate}} {{id}}</span>
    <span class="pb-4">{{'recordNotFound.lowerMessage' | translate}}</span>
    <app-button-secondary [routerLink]="['/record-list']">{{'recordNotFound.button' | translate}}</app-button-secondary>
  </div>
</div>
